module.exports = __webpack_public_path__ + "static/media/fk.12d25ef6.svg";